import { Button } from '@/components/ui';
import { INVITEE_COPY } from './inviteeOnboardingCopy';

export function InviteeLinkState({
  state,
  onDismiss,
  onRetry,
  expiryLabel,
}: {
  state: 'loading' | 'expired' | 'unavailable' | 'deferred' | 'error';
  /** Server-reported invite lifetime for the expired copy (YAR-371). */
  expiryLabel?: string | null;
  onDismiss?: () => void;
  onRetry?: () => void;
}) {
  const title =
    state === 'expired'
      ? INVITEE_COPY.hero.expiredTitle
      : state === 'unavailable'
        ? INVITEE_COPY.hero.unavailableTitle
        : state === 'deferred'
          ? 'This invite isn’t ready yet'
          : state === 'error'
            ? 'We couldn’t load this invite'
            : 'Loading invite…';
  const body =
    state === 'expired'
      ? INVITEE_COPY.hero.expiredBody(expiryLabel)
      : state === 'unavailable'
        ? INVITEE_COPY.hero.unavailableBody
        : state === 'deferred'
          ? // Co-admin invitee onboarding is deferred (YAR-290). Saying so
            // plainly beats the old copy, which claimed a perfectly valid
            // invite had "already been used or declined".
            'Co-admin invites aren’t available yet. Ask your household admin to invite you with Can edit or Can view access.'
          : state === 'error'
            ? 'Check your connection and try again.'
            : null;

  return (
    <div className="h-dvh bg-surface px-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] pt-5">
      <div className="mx-auto flex h-full w-full max-w-sm flex-col">
        <div className="flex flex-1 flex-col items-center justify-center gap-8 text-center">
          <div className="flex items-center gap-1">
            <img
              src="/logo.svg"
              alt=""
              width={48}
              height={48}
            />
            <span className="text-[32px] leading-10 font-bold text-primary">
              Yaruta
            </span>
          </div>
          <div className="flex flex-col gap-3">
            <h1 className="text-[28px] leading-8 font-bold text-text-hero">
              {title}
            </h1>
            {body && (
              <p className="text-lg leading-7 text-muted-foreground">{body}</p>
            )}
          </div>
          {state === 'loading' && (
            <div
              className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"
              aria-label="Loading"
            />
          )}
        </div>
        {onDismiss && (
          <Button
            variant="primary"
            fullWidth
            onClick={onDismiss}
          >
            Dismiss
          </Button>
        )}
        {onRetry && (
          <Button
            variant="primary"
            fullWidth
            onClick={onRetry}
          >
            Try again
          </Button>
        )}
      </div>
    </div>
  );
}
